<template>
    <div class="c-algolia-search__results">
        <div v-if="loading">
            <div class="c-algolia-search__note">Loading search results...</div>
        </div>

        <div v-if="!loading && !hasSearched">
            <div class="c-algolia-search__note">
                <i>Please enter a search query in the sidebar and click search.</i>
            </div>
        </div>

        <div v-if="hasSearched && searchText">

            <div
                v-if="searchResult.results.length == 0 && !loading && hasSearched"
                class="c-algolia-search__note"
            >
                Sorry, there are no results for "<span class="c-algolia-search__note-bold">{{ lastSearchedFor.searchText }}</span>" in
                <span class="c-algolia-search__note-bold">{{ lastSearchedFor.selectedGroup }}</span>.
            </div>

        </div>

        <div
            v-if="searchResult.results.length > 0 && !loading"
            class="c-algolia-search__note"
        >
            Searched <span class="c-algolia-search__note-bold">{{ lastSearchedFor.selectedGroup }}</span>
                <span v-if="lastSearchedFor.searchText"> for "<span class="c-algolia-search__note-bold">{{ lastSearchedFor.searchText }}</span>"</span>
                 and got {{ searchResult.totalResults }} results.

            <span v-if="searchResult.totalPages > 1">
                Showing page {{ searchResult.currentPage }} of
                {{ searchResult.totalPages }}.
            </span>
        </div>

        <div class="c-algolia-search__results-wrapper">

            <div
                :class="[
                    'c-algolia-search__loading-animation',
                    { 'c-algolia-search__loading-animation--visible': loading },
                ]"
                >
                <div class="c-algolia-search__loading-wrapper">
                    <div class="c-algolia-search__loading-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    </div>
                </div>
            </div>

            <div
                v-for="result in searchResult.results"
                :class="[
                    `c-algolia-search__result`,
                    { 'c-algolia-search__result--loading': loading },
                ]"
                :key="result.title + result.id"
            >
                <p 
                    v-if="result.guidelinePageTitle" 
                    class="c-algolia-search__result-parent" 
                    :class="`c-algolia-search__result-parent--${result.groupPageColour}`"
                >
                    <a :href="result.guidelinePageLink">{{ result.guidelinePageTitle }}</a>
                </p>

                <div class="c-algolia-search__result-wrapper">

                    <h3 class="c-algolia-search__result-title">
                        <a :href="result.accordionURL" class="c-algolia-search__result-link" :target="result.documentURL ? '_blank' : '_self'">
                            {{ result.title }}
                            <small class="c-algolia-search__result-document" v-if="result.documentURL">({{ result.documentType }} {{ result.documentSize }})</small>
                        </a>
                    </h3>

                    <p v-if="result.excerpt" class="c-algolia-search__result-excerpt">
                        <span v-html="result.excerpt"></span>
                        <a class="c-algolia-search__result-readmore" :href="result.accordionURL">
                            Read more
                        </a>
                    </p>
                    
                    <a :href="result.groupPageLink" v-if="result.groupPageTitle" class="c-algolia-search__result-tag">{{ result.groupPageTitle }}</a>
                    
                </div>

                <!-- <p class="c-algolia-search__result-meta">
                    Updated {{ result.date }}
                </p> -->

            </div>

            <div
                class="c-algolia-search__pagination"
                v-if="searchResult.results.length > 0"
            >
                <button
                    class="c-algolia-search__pagination-button"
                    v-if="searchResult.currentPage > 1"
                    @click="prevPageSearch"
                >
                    Prev
                </button>
                <div v-else></div>

                <div class="c-algolia-search__pagination-pages-wrapper">
                    <button
                        v-for="page in searchResult.totalPages"
                        @click="goToPage(page)"
                        :key="page"
                        :class="[
                        'c-algolia-search__pagination-button',
                        {
                            'c-algolia-search__pagination-button--active':
                            page === searchResult.currentPage,
                        },
                        ]"
                    >
                        {{ page }}
                    </button>
                </div>

                <button
                    class="c-algolia-search__pagination-button"
                    v-if="searchResult.currentPage < searchResult.totalPages"
                    @click="nextPageSearch"
                >
                    Next
                </button>
                <div v-else></div>

            </div>

                
        </div>

    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
    data() {
        return {};
    },
    mounted() {},
    computed: {
        ...mapFields([
        "searchApp.lastSearchedFor",
        "searchApp.searchResult",
        "searchApp.state.hasSearched",
        "searchApp.state.loading",
        "searchApp.search.start",
        "searchApp.search.searchText",
        "searchApp.search.selectedGroup",
        ]),
    },
    methods: {
        goToPage(page) {
            this.start = (page - 1) * 15;
            this.scrollToResults();
            this.$store.dispatch("submitSearch");
        },
        nextPageSearch() {
            this.start = this.searchResult.nextStart;
            this.scrollToResults();
            this.$store.dispatch("submitSearch");
        },
        prevPageSearch() {
            this.start = this.searchResult.prevStart;
            this.scrollToResults();
            this.$store.dispatch("submitSearch");
        },
        scrollToResults() {
            const pageHeader = document.querySelector(".c-algolia-search__results");
            if (pageHeader) {
                pageHeader.scrollIntoView({ behavior: "smooth" });
            }
        },
        getFileExtension(url) {
            return url?.includes(".") ? url.split(".").pop() : "";
        },
    },
};

</script>